import { render, staticRenderFns } from "./CustomersPage.vue?vue&type=template&id=457cd4e6"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"
import style0 from "./CustomersPage.vue?vue&type=style&index=0&id=457cd4e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports